<template>
    <div>
        <div class="tab mgr-0 mgl-0" v-if="hasOneOnglet">
            <ul>
                <li
                    v-for="onglet in onglets"
                    :key="onglet.key"
                    :class="{ 'is-active': activeTab === onglet.key }"
                    @click="setActiveTab(onglet)">
                    {{ onglet.title }}
                </li>
            </ul>
        </div>
        <slot :name="activeTab" :activeTab="activeTab"/>
    </div>
</template>

<script>
export default {
  name: 'OngletManager',
  props: {
    onglets: {
      type: Array,
      required: true,
    },
    startKey: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      activeTab: null,
    };
  },
  computed: {
    hasOneOnglet() {
      return this.onglets.length > 0;
    },
  },
  methods: {
    setActiveTab(onglet) {
      this.activeTab = onglet.key;
      if (!!onglet.action && typeof onglet.action === 'function') {
        onglet.action();
      }
    },
  },
  mounted() {
    if (this.hasOneOnglet) {
      this.activeTab = this.startKey ?? this.onglets[0]?.key;
    }
  },
};
</script>
